export const columns = [
  {
    accessorKey: "type",
    header: "Storage Type",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "dayStart",
    header: "Slab Day From",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "dayEnd",
    header: "Slab Day To",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "charges",
    header: "Slab Charges",
    type: "number",
    flex: 1,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
